module.exports = __webpack_public_path__ + "img/loading.990237fe.gif";